<template>
  <div id="app">
    <!-- <demo/> -->
    <router-view v-if="isLogined"/>
    <div v-else class="oasis-login-tips">
      <p>用户没有登录,请先登录</p>
    </div>
  </div>
</template>

<script>
// import demo from './views/demo/index.vue';
// import { getCookie } from './utils/url'
export default {
  name: 'App',
  components: {
    // demo,
  },
  data() {
    return {
      isLogined: false,
    };
  },
  created() {
    this.isLogined = true;
    // const env = process.env.BUILD_ENV;
    // const hasOasisId = getCookie('oasisSessionId');
    // console.log(env, hasOasisId)
    // if (env !== 'development' && !hasOasisId) {
    //   this.isLogined = false;
    //   let oasisRedirectUrl = encodeURIComponent(`${host}/video/#/`)
    //   const host = window.location.origin;
    //   let href = `${host}/resources/index.html?needLogin=1&oasisRedirectUrl=${oasisRedirectUrl}`
    //   window.location.href = href
    // }
  },
  
  mounted() {
  },
};
</script>

<style>
#app {
  padding-top: 56px;
}

.oasis-login-tips {
  margin-top: 32px;
  text-align: center;
}
</style>
